import script from "./Linyuan.vue?vue&type=script&setup=true&lang=js"
export * from "./Linyuan.vue?vue&type=script&setup=true&lang=js"

import "./Linyuan.vue?vue&type=style&index=0&id=2d5d2df2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d5d2df2"]])

export default __exports__